import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const OurClients = ({ content }) => {
    const [isVisible, setIsVisible] = useState(false);
    const componentRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (componentRef.current) {
                const top = componentRef.current.getBoundingClientRect().top;
                if (top < window.innerHeight) setIsVisible(true);
            }
        };
        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const settings = {
        centerMode: true,
        centerPadding: "120px",
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 500,
        slidesToShow: 3,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024, // Tablet
                settings: {
                    slidesToShow: 3,
                    centerPadding: "30px",
                },
            },
            {
                breakpoint: 768, // Mobile
                settings: {
                    slidesToShow: 2,
                    centerPadding: "40px",
                },
            },
            {
                breakpoint: 460, // Mobile
                settings: {
                    slidesToShow: 1,
                    centerPadding: "30px",
                },
            },
        ],
    };

    return (
        <div
            ref={componentRef}
            className={`w-full py-20 transition-opacity duration-500 ${isVisible ? "opacity-100" : "opacity-0"
                }`}
        >
            {/* Dynamic Heading */}
            <h2 className="lg:text-6xl md:text-3xl text-xl lg:px-[100px] md:px-[60px] px-[30px] font-bold text-white">
                <span className="text-yellow-500">{content.title.split(" ")[0]}</span>{" "}
                {content.title.split(" ").slice(1).join(" ")}
            </h2>

            <div className="px-5 md:px-16 py-16">
                <Slider {...settings}>
                    {content.data.map((tech, index) => (
                        <div key={index} className="px-3">
                            <div className="bg-white w-[250px] shadow-xl rounded-2xl p-6 text-center group hover:scale-95 transition-all duration-300">
                                <div className="flex justify-center mb-4">
                                    <img
                                        src={tech.icon}
                                        alt={tech.name}
                                        className="w-20 h-20 object-contain group-hover:scale-110 transition-transform duration-300"
                                    />
                                </div>
                                <h4 className="text-lg font-semibold text-gray-900 group-hover:text-black">
                                    {tech.name}
                                </h4>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    );
};

export default OurClients;
